package com.klantenstop.web.data.models.dto.responses

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CuratedCityDto(
    val id: String = "",
    val slug: String = "",
    val name: String = "",
    val province: String = "",
    val latitude: Double = 0.0,
    val longitude: Double = 0.0,
    val country: String = "BE",
    @SerialName("is_featured")
    val isFeatured: Boolean = false,
    @SerialName("created_at")
    val createdAt: String = "",
    @SerialName("updated_at")
    val updatedAt: String = "",
)
